var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCiCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9V7.13333C8.5 6.38667 8.5 6.01333 8.64533 5.728C8.77333 5.47667 8.97667 5.27333 9.228 5.14533C9.51333 5 9.88667 5 10.6333 5H14.3667C15.1133 5 15.4867 5 15.772 5.14533C16.0229 5.27316 16.2268 5.47713 16.3547 5.728C16.5 6.01333 16.5 6.38667 16.5 7.13333V10.8667C16.5 11.6133 16.5 11.9867 16.3547 12.272C16.2268 12.5228 16.0228 12.7268 15.772 12.8547C15.4867 13 15.1133 13 14.3687 13H12.5M8.5 9H6.63333C5.88667 9 5.51333 9 5.228 9.14533C4.9771 9.27313 4.77313 9.4771 4.64533 9.728C4.5 10.0133 4.5 10.3867 4.5 11.1333V14.8667C4.5 15.6133 4.5 15.9867 4.64533 16.272C4.77316 16.5229 4.97713 16.7268 5.228 16.8547C5.51267 17 5.886 17 6.63133 17H10.3693C11.114 17 11.4867 17 11.772 16.8547C12.0229 16.7268 12.2268 16.5229 12.3547 16.272C12.5 15.9867 12.5 15.614 12.5 14.8687V13M8.5 9H10.3667C11.1133 9 11.4867 9 11.772 9.14533C12.0229 9.27316 12.2268 9.47713 12.3547 9.728C12.5 10.0127 12.5 10.386 12.5 11.1313V13",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiCopy);
export default __webpack_public_path__ + "static/media/ci_copy.dc2b969cd2a193ac35f521f71c3ea344.svg";
export { ForwardRef as ReactComponent };